/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Input } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormInputItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, name, value, label,
  } = formField;

  const handleOnChange = (e) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[id].value = e.target.value;
    setPageData(updatedPageData);
  };

  return (
    <Input
      id={`${id}-input-${name}`}
      key={`${id}-input-${name}`}
      value={value}
      onChange={(e) => {
        handleOnChange(e);
      }}
      css={advFormStyles['.fullWidth']}
      placeholder={label}
    />
  );
});
AdvFormInputItem.displayName = 'AdvFormInputItem';

AdvFormInputItem.propTypes = {
  formFields: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,

};
export default AdvFormInputItem;
